module.exports = __webpack_public_path__ + "static/img/code.37e06afb.png";